import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertCards(props) {
  const { alertDetails, confirmAlert } = props;
  const [details, setDetails] = useState({
    openAlert: false,
    textAlert: "",
    typeAlert: "",
  });

  useEffect(() => {
    const { openAlert, textAlert, typeAlert } = alertDetails;
    setDetails({ openAlert, textAlert, typeAlert });
  }, [alertDetails]);

  return (
    <div>
      <Dialog
        open={details["openAlert"]}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          confirmAlert("cancel");
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          sx={{
            mb: 1,
            bgcolor: details["typeAlert"] == "delete" ? "#870000" : "#684400",
          }}
        >
          {"آیا مطمین هستید"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {details["textAlert"]}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              confirmAlert("cancel");
            }}
          >
            لغو
          </Button>
          <Button
            onClick={() => {
              confirmAlert(details["typeAlert"]);
            }}
          >
            بله
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
